import { Box } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const ProviderInfoContainer = styled(Box)`
  flex-shrink: 1;
  div {
    flex-shrink: 1;
  }
`

export const SegmentColor = styled(Box).withConfig({
  shouldForwardProp: (prop) => !['bgColor'].includes(prop),
})<{ bgColor: string }>`
  height: 8px;
  width: 8px;
  background-color: ${(props) => props.bgColor};
  border-radius: 50%;
`
